import { CustomTooltip } from '@cian/ui-kit';
import * as React from 'react';

import { trackingMyHomeIconClick } from './tracking';
import { MyHomeLinkLayout } from '../../components/MyHomeLink';

export const MyHomeDesktopContainer: React.FC = () => {
  // TODO: логика тултива в задаче CD-196987
  const [isOpen, setOpen] = React.useState(false);
  const tooltipRef = React.useRef<HTMLDivElement>(null);

  return (
    <MyHomeLinkLayout onClick={trackingMyHomeIconClick}>
      <span ref={tooltipRef}>Мой дом</span>

      <CustomTooltip
        open={isOpen}
        onClose={() => setOpen(false)}
        content="Расскажем всё, что нужно для выгодной продажи, сдачи и поиска нового жилья"
        placement="bottom-start"
        theme="blue"
        arrow={true}
        closeButton
        anchorRef={tooltipRef}
        maxWidth={320}
      />
    </MyHomeLinkLayout>
  );
};
